import type { Screen, Session } from '../types';
import { BrandMark } from './BrandMark';
import { Icon } from './Icon';

interface Props {
  screen: Screen;
  session: Session;
  onNavigate: (screen: Screen) => void;
  onLogout: () => void;
}

const baseItems: Array<{ id: Screen; label: string; icon: 'home' | 'partner' | 'live' | 'guide' | 'movies' | 'series' }> = [
  { id: 'home', label: 'Início', icon: 'home' },
  { id: 'live', label: 'Ao vivo', icon: 'live' },
  { id: 'guide', label: 'Guia', icon: 'guide' },
  { id: 'movies', label: 'Filmes', icon: 'movies' },
  { id: 'series', label: 'Séries', icon: 'series' },
];

export function Sidebar({ screen, session, onNavigate, onLogout }: Props) {
  const items = session.partner?.slug !== 'innova' && session.partner?.features?.length
    ? [baseItems[0], { id: 'partner' as const, label: session.partner.short_name || session.partner.name, icon: 'partner' as const }, ...baseItems.slice(1)]
    : baseItems;
  const navigate = (target: Screen) => {
    onNavigate(target);
    window.setTimeout(() => {
      document.querySelector<HTMLElement>('[data-content-autofocus="true"]')?.focus();
    }, 0);
  };

  return (
    <aside className="sidebar">
      <div className="sidebar__brand sidebar__brand--compact"><BrandMark compact /></div>
      <div className="sidebar__brand sidebar__brand--expanded"><BrandMark theme={session.partner} /></div>
      <nav aria-label="Navegação principal">
        {items.map(item => (
          <button
            key={item.id}
            data-focusable="true"
            data-focus-zone="sidebar"
            data-focus-key={`nav-${item.id}`}
            className={screen === item.id ? 'active' : ''}
            onClick={() => navigate(item.id)}
            data-testid={`nav-${item.id}`}
          >
            <Icon name={item.icon} /><span>{item.label}</span>
          </button>
        ))}
      </nav>
      <div className="sidebar__bottom">
        <div className="profile-summary" aria-label={`Perfil de ${session.name}`}>
          <span className="avatar"><Icon name="user" /></span>
          <span><strong>{session.name}</strong><small>{session.email}</small></span>
        </div>
        <button data-focusable="true" data-focus-zone="sidebar" data-focus-key="logout" onClick={onLogout} data-testid="logout">
          <Icon name="exit" /><span>Sair</span>
        </button>
      </div>
    </aside>
  );
}
